// Chatbot panel-open state — the feature's out-of-Apollo-cache client state; the
// service keeps the access gate + remote-config logic. See CLAUDE.md store rule.
import { createStore } from './create-store';

const [useIsChatbotPanelOpen, getChatbotPanelOpen, setChatbotPanelOpen] = createStore(false);
export { useIsChatbotPanelOpen };

export const openChatbotPanel = (): void => setChatbotPanelOpen(true);
export const closeChatbotPanel = (): void => setChatbotPanelOpen(false);
export const toggleChatbotPanel = (): void => setChatbotPanelOpen(!getChatbotPanelOpen());
